import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  readTaskListFilters,
  type TaskListFilters,
  writeTaskListFilters,
} from "@/utils/taskListFilters";

/**
 * The selected tasks filters, persisted as URL search params. Setter replaces
 * the URL search params, so changing filters don't add to browser history.
 */
export const useTaskListFilters = (): [
  TaskListFilters,
  (filters: TaskListFilters) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(
    () => readTaskListFilters(searchParams),
    [searchParams],
  );

  const setFilters = useCallback(
    (selectedFilters: TaskListFilters) =>
      setSearchParams(
        (currentSearchParams) =>
          writeTaskListFilters(currentSearchParams, selectedFilters),
        {
          replace: true,
        },
      ),
    [setSearchParams],
  );

  return [filters, setFilters];
};
